import React, { useEffect, useState } from "react";
import {
  aiware_logo,
  aiware_logo_png,
  company_logo,
  knf_logo,
  logo,
  profile,
} from "../../assets/imgs";
import { useLazyViewAdminQuery } from "../../screens/redux/api/api";
import apiRequest from "../../screens/redux/api/apiRequest";
import { useLocation } from "react-router-dom";

const Topbar = ({ setRoleText, roleText }) => {
  const [saideBarShow, setSaidBarShow] = useState(true);
  const userdata = JSON.parse(localStorage.getItem("user_details"));
  const logindata = JSON.parse(localStorage.getItem("loginData"));
  const userlogo = JSON.parse(localStorage.getItem("company"));
  const givenpermissions = JSON.parse(localStorage.getItem("user_permission"));
  const [viewAdmin] = useLazyViewAdminQuery();
  const loginType = localStorage.getItem("type");
  const location = useLocation();
  const pathname = location?.pathname;

  const getUserdata = async (id) => {
    const res = await apiRequest(viewAdmin, id);
    if (res?.status == "success") {
      // givenpermissions?.length != res?.permission
    }
    // console.log(res);
  };

  useEffect(() => {
    if (userdata?.id) {
      // getUserdata(userdata?.id);
    }
  }, []);

  const knfWasURLS = [
    "/role",
    "/add-role",
    "/company-role",
    "/company-role-add",
    "/company",
    "/daily-log",
    "/user-list",
    "/notificationreport",
    "/members-list",
    "/device-list",
    "/report",
    "/location-marks",
    "/log-file",
    "/role",
  ];

  const aiwareURLS = [
    "/admin-dashboard",
    "/super-admin-roles",
    "/super-admin-roles-add",
    "/superadmin-company-roles",
    "/superadmin-company-roles-view",
    "/admin-company-list",
    "/admin-add-company",
    "/add-company",
    "/sites-view",
    "/sites-list",
    "/alert-types",
    "/user-report",
    "/site-report",
    "/Overall-notifications",
    "/alert-types-camera",
    "/group-users",
    "/alert-days",
  ];
  // console.log("pathname", pathname === "/admin-list");

  const { sites, knf_type } = JSON.parse(
    localStorage.getItem("user_details") ?? "{}",
  );
  // console.log("sites", sites);

  return (
    <div className="d-flex ac-jb topbar">
      <div className="d-flex ac-jc">
        {logindata?.type == "admin" ? (
          <div className="image_text pointer mt-1 me-2">
            {(pathname === "/admin-list" ||
              pathname === "/landing-page" ||
              pathname === "/in-app") && (
              <img src={knf_logo} className="knf-logo" alt="" />
            )}
            {knfWasURLS?.includes(pathname) && (
              <div className="d-flex ac-js">
                <img src={logo} className="admin-logo" alt="" />
                <h2 className="f3 fs-sm-12 fs-md-16 fs-lg-18 fs-xl-20 fs-xxl-22 mx-2">
                  {userlogo?.name ? userlogo?.name : " KNF WAS@SG"}
                </h2>
              </div>
            )}
            {aiwareURLS?.includes(pathname) && (
              <div className="d-flex ac-js">
                <img src={aiware_logo_png} className="admin-logo" alt="" />
                <h2 className="f3 fs-sm-12 fs-md-16 fs-lg-18 fs-xl-20 fs-xxl-22 mx-2">
                  {userlogo?.name ? userlogo?.name : " AIWARE"}
                </h2>
              </div>
            )}
          </div>
        ) : (
          <>
            {userdata?.role?.id &&
              !userdata?.knf_role?.id &&
              logindata?.role !== "Super Admin" &&
              logindata?.knf_role !== "Knf Super Admin" && (
                <div className="image_text pointer mt-1 me-2">
                  {pathname === "/admin-list" && (
                    <img src={knf_logo} className="knf-logo" alt="" />
                  )}
                  {/* <img src={knf_logo} className="knf-logo" alt="" /> */}
                  <div className="d-flex ac-js">
                    <img
                      src={userlogo?.logo ? userlogo?.logo : logo}
                      className="admin-logo"
                      alt=""
                    />
                    <h2 className="f3 fs-sm-12 fs-md-16 fs-lg-18 fs-xl-20 fs-xxl-22 mx-2">
                      {userlogo?.name ? userlogo?.name : " KNF WAS@SG"}
                    </h2>
                  </div>
                </div>
              )}

            {userdata?.knf_role?.id &&
              !userdata?.role?.id &&
              logindata?.role !== "Super Admin" &&
              logindata?.knf_role !== "Knf Super Admin" && (
                <div className="image_text pointer mt-1 me-2">
                  {pathname === "/admin-list" && (
                    <img src={knf_logo} className="knf-logo" alt="" />
                  )}
                  {/* <img src={knf_logo} className="knf-logo" alt="" /> */}
                  <div className="d-flex ac-js">
                    <img
                      src={userlogo?.logo ? userlogo?.logo : logo}
                      className="admin-logo"
                      alt=""
                    />
                    <h2 className="f3 fs-sm-12 fs-md-16 fs-lg-18 fs-xl-20 fs-xxl-22 mx-2">
                      {userlogo?.name ? userlogo?.name : " AIWARE"}
                    </h2>
                  </div>
                </div>
              )}

            {userdata?.role?.id &&
              userdata?.knf_role?.id &&
              logindata?.role !== "Super Admin" &&
              logindata?.knf_role !== "Knf Super Admin" && (
                <div className="image_text pointer mt-1 me-2">
                  {pathname === "/admin-list" && (
                    <img src={knf_logo} className="knf-logo" alt="" />
                  )}
                  {/* <img src={knf_logo} className="knf-logo" alt="" /> */}
                  <div className="d-flex ac-js">
                    <img
                      src={userlogo?.logo ? userlogo?.logo : logo}
                      className="admin-logo"
                      alt=""
                    />
                    <h2 className="f3 fs-sm-12 fs-md-16 fs-lg-18 fs-xl-20 fs-xxl-22 mx-2">
                      {userlogo?.name ? userlogo?.name : " KNF WAS@SG"}
                    </h2>
                  </div>
                </div>
              )}

            {logindata?.role !== "Super Admin" &&
              logindata?.knf_role !== "Knf Super Admin" &&
              !userdata?.role?.id &&
              !userdata?.knf_role?.id &&
              userdata?.knf_type >= 1 &&
              userdata?.knf_type <= 5 && (
                <>
                  <div className="image_text pointer mt-1 me-2">
                    {pathname === "/admin-list" && (
                      <img src={knf_logo} className="knf-logo" alt="" />
                    )}
                    {/* <img src={knf_logo} className="knf-logo" alt="" /> */}
                    <div className="d-flex ac-js">
                      <img
                        src={
                          logindata?.company?.logo
                            ? logindata?.company?.logo
                            : aiware_logo_png
                        }
                        className="admin-logo"
                        alt=""
                      />
                      <h2 className="f3 fs-sm-12 fs-md-16 fs-lg-18 fs-xl-20 fs-xxl-22 mx-2">
                        {logindata?.company?.name
                          ? logindata?.company?.name
                          : ""}
                      </h2>
                    </div>
                  </div>
                </>
              )}
          </>
        )}
        {/*<div className="d-flex">
            <p className="f3 fs-xs-10 fs-sm-11 fs-md-12 fs-lg-13 fs-xl-14 fs-xxl-15 border-right pe-3 mb-0">
              Creating Space
            </p>
            <p className="f3 fs-xs-10 fs-sm-11 fs-md-12 fs-lg-13 fs-xl-14 fs-xxl-15 ps-3 mb-0">
              Creating Home
            </p>
          </div> */}
      </div>
      <div className="d-flex ac-jc">
        <img
          src={userdata?.profile_image ? userdata?.profile_image : profile}
          className="profile-img me-2"
          alt=""
        />
        <div>
          <h2 className="f3  fs-sm-12 fs-md-14 fs-lg-16 fs-xl-18 fs-xxl-20 text-nowrap">
            Welcome: {userdata?.name}
          </h2>
          <p className="f3 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 mb-0 text-nowrap">
            Role :
            <span className="f1 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18">
              {userdata?.role?.name ? userdata?.role?.name + " ," : " "}
              {userdata?.knf_type == 2
                ? "Site Admin"
                : userdata?.knf_type == 3
                  ? "Group User 1"
                  : userdata?.knf_type == 4
                    ? "Group User 2"
                    : userdata?.knf_type == 5
                      ? "Group User 3"
                      : userdata?.knf_role?.name
                        ? userdata?.knf_role?.name.replace(
                            /^.*?\s(?=Company Admin)/,
                            "",
                          )
                        : ""}

              {/* {roleText == "knf"
                ? userdata?.role?.name
                  ? userdata?.role?.name
                  : loginType == "Company Sub Admin"
                    ? "SubAdmin"
                    : loginType == "Company User"
                      ? "User"
                      : "Company Manager"
                : roleText == "aiware"
                  ? userdata?.knf_role?.name
                    ? userdata?.knf_role?.name == "Knf Super Admin"
                      ? "Super Admin"
                      : userdata?.knf_role?.name == "Knf Company Admin"
                        ? "Company Manager"
                        : userdata?.knf_role?.name
                    : userdata?.knf_type == 2
                      ? "Site Admin"
                      : userdata?.knf_type == 3
                        ? "Group User 1"
                        : userdata?.knf_type == 4
                          ? "Group User 2"
                          : userdata?.knf_type == 5
                            ? "Group User 3"
                            : "Company Manager"
                  : userdata?.role?.name
                    ? userdata?.role?.name
                    : loginType == "Company Sub Admin"
                      ? "SubAdmin"
                      : loginType == "Company User"
                        ? "User"
                        : userdata?.knf_role?.name
                          ? userdata?.knf_role?.name == "Knf Super Admin"
                            ? "Super Admin"
                            : userdata?.knf_role?.name == "Knf Company Admin"
                              ? "Company Manager"
                              : userdata?.knf_role?.name
                          : userdata?.knf_type == 2
                            ? "Site Admin"
                            : userdata?.knf_type == 3
                              ? "Group User 1"
                              : userdata?.knf_type == 4
                                ? "Group User 2"
                                : userdata?.knf_type == 5
                                  ? "Group User 3"
                                  : "Company Manager"} */}
              {/* {userdata?.role?.name
                ? userdata?.role?.name
                : userdata?.knf_role?.name
                ? // ? userdata?.knf_role?.name
                  "Company Manager"
                : userdata?.knf_type == 2
                ? "Site Admin"
                : userdata?.knf_type == 3
                ? "Group User 1"
                : userdata?.knf_type == 4
                ? "Group User 2"
                : userdata?.knf_type == 5
                ? "Group User 3"
                : ""} */}
            </span>
          </p>
          {sites?.name && sites?.code && knf_type == 2 && (
            <p className="f3 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 mb-0 text-nowrap">
              Site Name and Code :
              <span className="f1 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 text-wrap">
                {sites?.name} ({sites?.code})
              </span>
            </p>
          )}
        </div>
      </div>
    </div>
  );
};

export default Topbar;
